import React, { useState } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import "./ProgramBanner.css";
import { PiStudentFill } from "react-icons/pi";
import { MdManageAccounts } from "react-icons/md";
import { IoMdPersonAdd } from "react-icons/io";
import { RiGitRepositoryPrivateFill } from "react-icons/ri";
import { useAuth } from "../../Context/AuthContext";
import Notification from "../Notification/Notification";
import { useNavigate } from "react-router-dom";
import JoinProgramModal from "./JoinProgramModal";
import JoinCodeModal from "./JoinCodeModal";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function ProgramBanner(props) {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const { authData } = useAuth();
  const [showButton, setShowButton] = useState(
    !props.program.students_enrolled.some((student) => {
      return student._id === authData.userId;
    })
  );
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [existingProgress, setExistingProgress] = useState(false);
  const [notificationParams, setNotificationParams] = useState({
    show: false,
    message: t("notification_default_message"),
    bg: "success",
  });
  const [showCodeModal, setShowCodeModal] = useState(false);

  const handleJoinCourse = async (action) => {
    setError("");

    try {
      const actionParam = typeof action === "string" ? action : undefined;

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/requests`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            programCode: props.program.code,
            action: actionParam,
          }),
        }
      );

      const data = await response.json();

      if (response.status === 409) {
        setExistingProgress(true);
        setShowPopup(true);
        return;
      }

      if (!response.ok) {
        throw new Error(data.message || t("error_occurred"));
      }

      if (response.status === 201) {
        setNotificationParams((prev) => ({
          show: true,
          message: data.message,
          bg: "success",
        }));
        setShowButton(false);
      } else if (response.status === 202) {
        setNotificationParams((prev) => ({
          show: true,
          message: t("access_request_sent"),
          bg: "success",
        }));
        if (authData.role === "user") {
          setTimeout(() => {
            navigate("/myrequest");
          }, 2000);
        }
      }
    } catch (err) {
      console.error(t("error_captured"), err);
      setError(err.message || t("error_occurred"));
      setNotificationParams((prev) => ({
        show: true,
        message: err.message,
        bg: "danger",
      }));
    }
  };

  return (
    <>
      <Container className="d-flex align-items-center rounded-4 shadow">
        <Row className="w-100 m-5">
          <Col md={8} className="text-black">
            <h2>{props.program.title}</h2>
            <p>{props.program.description}</p>
            <p>
              {props.program.categorie} - {props.program.duration} {t("hours")}{" "}
              - {props.program.level}
            </p>

            {props.program.created_by ? (
              <p className="created-by fs-4">
                {t("created_by")}{" "}
                {props.program.created_by.first_name +
                  " " +
                  props.program.created_by.last_name}
              </p>
            ) : (
              <p className="created-by fs-4">{t("unknown_creator")}</p>
            )}
          </Col>
          {props.program.created_by &&
          authData.userId === props.program.created_by._id ? (
            <Col md={4}>
              <div className="d-flex flex-column">
                <Button
                  onClick={() =>
                    navigate(`/programs/${props.program.id}/manage`)
                  }
                  variant="primary"
                  className="mb-3"
                >
                  <MdManageAccounts className="me-2" />
                  {t("course_manager")}
                </Button>
                <Button variant="info" onClick={() => setShowCodeModal(true)}>
                  <PiStudentFill className="me-2" />
                  {t("invite_students")}
                </Button>
              </div>
            </Col>
          ) : null}
          {!props.program.students_enrolled.includes(authData.userId) &&
          !props.program.instructors.includes(authData.userId) &&
          (!props.program.created_by ||
            authData.userId !== props.program.created_by._id) ? (
            <div className="d-flex flex-column align-items-center">
              {props.program.is_public === false && showButton === true && (
                <RiGitRepositoryPrivateFill
                  size={30}
                  className="text-primary mb-2"
                />
              )}

              {showButton === true && (
                <Button
                  variant="primary"
                  className="mb-3"
                  onClick={handleJoinCourse}
                >
                  {(props.program.is_public === false &&
                    t("request_course_access")) ||
                    t("join_course")}
                </Button>
              )}

              {error && <div className="text-danger mt-2">{error}</div>}
            </div>
          ) : null}
        </Row>
        <Notification
          notificationParams={notificationParams}
          setNotificationParams={setNotificationParams}
        />
      </Container>

      <JoinProgramModal
        show={showPopup}
        onHide={() => setShowPopup(false)}
        programTitle={props.program.title}
        handleJoinCourse={handleJoinCourse}
      />

      <JoinCodeModal
        show={showCodeModal}
        onHide={() => setShowCodeModal(false)}
        programCode={props.program.code}
      />
    </>
  );
}

export default ProgramBanner;
